import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Grid, TextField, FormControl, Checkbox, FormGroup, FormControlLabel, FormLabel, InputLabel, Select, MenuItem } from "@mui/material";
import * as RoleActions from '../../../redux/actions/roleAction.js';
import axios from 'axios';
import { api_urls } from "../../../utils/api-urls/index.js";
import Swal from "sweetalert2";

export const AddSubAdmin = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { rolesData } = useSelector(state => state?.roleReducer);

  const [subAdminPermission, setSubAdminPermission] = useState([]);
  const [subAdminDetail, setSubAdminDetail] = useState({ name: '', email: '', contact: '', password: '', roleId: '' });
  const [inputFieldError, setInputFieldError] = useState({ name: '', email: '', contact: '', password: '', subAdminPermission: '' });

  useEffect(() => {
    dispatch(RoleActions.getRoles());
  }, []);

  const handleInputFieldError = (input, value) => {
    setInputFieldError((prev) => ({ ...prev, [input]: value }));
  };

  const handleInputField = (e) => {
    const { name, value } = e.target;
    setSubAdminDetail({ ...subAdminDetail, [name]: value });
  };

  const handleSubAdminPermission = (e) => {
    const value = e.target.value;
    const isChecked = e.target.checked;
    if (isChecked) setSubAdminPermission([...subAdminPermission, value]);
    else setSubAdminPermission(subAdminPermission.filter(item => item !== value));
  };

  const handleRoleChange = (e) => {
    const roleId = e.target.value;
    setSubAdminDetail(prev => ({ ...prev, roleId }));
    if (roleId) {
      const role = rolesData.find(r => r._id === roleId);
      if (role) {
        const perms = role.permissions.filter(p => p.view || p.add || p.edit || p.delete).map(p => p.module);
        setSubAdminPermission(perms);
      }
    } else {
      setSubAdminPermission([]);
    }
  };

  const handleValidation = () => {
    let isValid = true;
    const { name, email, contact, password, roleId } = subAdminDetail;
    if (!name) { handleInputFieldError("name", "Please Enter Name"); isValid = false; }
    if (!email) { handleInputFieldError("email", "Please Enter Email"); isValid = false; }
    if (!contact) { handleInputFieldError("contact", "Please Enter Contact"); isValid = false; }
    if (!password) { handleInputFieldError("password", "Please Enter Password"); isValid = false; }
    if (subAdminPermission.length <= 0 && !roleId) {
      handleInputFieldError("subAdminPermission", "Please Select a Role or at least one Permission");
      isValid = false;
    }
    return isValid;
  };

  const handleSubmit = async () => {
    if (handleValidation()) {
      try {
        const { name, email, contact, password, roleId } = subAdminDetail;
        const userId = localStorage.getItem('userId');
        const payload = { name, email, contact, password, permission: subAdminPermission, createdBy: userId, adminName: 'Admin' };
        if (roleId) payload.roleId = roleId;

        const { data } = await axios.post(api_urls + 'api/admin/addSubAdminWithRole', payload);
        if (data?.status) {
          Swal.fire({ icon: "success", title: "Sub Admin Created Successfully", text: "Login credentials sent to email", showConfirmButton: false, timer: 3000 });
          navigate("/sub-admin");
        }
      } catch (err) {
        Swal.fire({ icon: "error", title: "Failed To Create Sub Admin", text: err?.response?.data?.message || "Something went wrong", showConfirmButton: false, timer: 2000 });
      }
    }
  };

  const subAdminPermissionData = [
    { name: "Dashboard" }, { name: "User" }, { name: "Sub Admin" }, { name: "Banner" },
    { name: "Category" }, { name: "Sub Category" }, { name: "Yatra" }, { name: "Sanchar" },
    { name: "Ecommerce" }, { name: "Religious" }, { name: "Static Pages" }, { name: "Astrologer" },
    { name: "Notifications" }, { name: "App Config" }, { name: "Utilities" }, { name: "Astro Mall" },
    { name: "Astro Puja" }, { name: "Services History" }, { name: "TBO Bookings" },
    { name: "Milan Sathi" }, { name: "Astrologer Admin" }, { name: "Post Banao" },
    { name: "Rojgar" }, { name: "Marketplace" }, { name: "Sanatani Manch" },
    { name: "Transaction" }, { name: "Operator Images" }, { name: "Flight Images" },
    { name: "Reports" }, { name: "App Errors" }, { name: "Roles & Logs" },
  ];

  return (
    <div style={{ padding: "20px", backgroundColor: "#fff", marginBottom: "20px", boxShadow: '0px 0px 5px lightgrey', borderRadius: "10px" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "30px", fontFamily: 'Philosopher' }}>
        <div style={{ fontSize: "20px", fontWeight: "600", color: "#667284" }}>Add Sub-Admin</div>
        <div onClick={() => navigate("/sub-admin")} style={{ fontWeight: "600", backgroundColor: "#164E62", color: "#fff", padding: "5px 10px", borderRadius: "5px", cursor: "pointer", fontSize: "14px" }}>Display</div>
      </div>

      <Grid container spacing={2} sx={{ color: "#000", fontFamily: "Philosopher" }}>
        <Grid item lg={6} md={6} sm={12} xs={12}>
          <TextField label="Name" variant='outlined' fullWidth name='name' value={subAdminDetail?.name} onChange={handleInputField}
            error={!!inputFieldError.name} helperText={inputFieldError.name} onFocus={() => handleInputFieldError("name", null)} />
        </Grid>
        <Grid item lg={6} md={6} sm={12} xs={12}>
          <TextField label="Email" variant='outlined' fullWidth name='email' value={subAdminDetail?.email} onChange={handleInputField}
            error={!!inputFieldError.email} helperText={inputFieldError.email} onFocus={() => handleInputFieldError("email", null)} />
        </Grid>
        <Grid item lg={6} md={6} sm={12} xs={12}>
          <TextField label="Contact" variant='outlined' fullWidth name='contact' value={subAdminDetail?.contact} onChange={handleInputField}
            error={!!inputFieldError.contact} helperText={inputFieldError.contact} onFocus={() => handleInputFieldError("contact", null)} />
        </Grid>
        <Grid item lg={6} sm={12} md={12} xs={12}>
          <TextField label="Password" variant='outlined' fullWidth name='password' value={subAdminDetail?.password} onChange={handleInputField}
            error={!!inputFieldError.password} helperText={inputFieldError.password} onFocus={() => handleInputFieldError("password", null)} />
        </Grid>

        <Grid item lg={12} sm={12} md={12} xs={12}>
          <FormControl fullWidth>
            <InputLabel>Assign Role (Optional)</InputLabel>
            <Select value={subAdminDetail.roleId} label="Assign Role (Optional)" onChange={handleRoleChange}>
              <MenuItem value="">No Role - Select Custom Permissions Below</MenuItem>
              {rolesData.filter(r => r.isActive).map(role => (
                <MenuItem key={role._id} value={role._id}>
                  {role.name}{role.description ? ' - ' + role.description : ''} ({role.permissions?.filter(p => p.view || p.add || p.edit || p.delete).length} modules)
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          {subAdminDetail.roleId && (
            <div style={{ marginTop: "8px", padding: "8px 12px", backgroundColor: "#e8f5e9", borderRadius: "4px", fontSize: "13px", color: "#2e7d32" }}>
              Role selected. Permissions are automatically assigned from the role.
            </div>
          )}
        </Grid>

        <Grid item lg={12} sm={12} md={12} xs={12}>
          <FormLabel component="legend">
            Permissions {subAdminDetail.roleId ? '(Assigned from Role)' : '(Select Manually)'}
          </FormLabel>
          <FormGroup aria-label="position" row>
            {subAdminPermissionData.map((value, index) => (
              <div key={index}>
                <FormControlLabel label={value.name}
                  control={<Checkbox checked={subAdminPermission.includes(value.name)} disabled={!!subAdminDetail.roleId} />}
                  name={value.name} value={value.name}
                  onChange={(e) => handleSubAdminPermission(e)}
                  onFocus={() => handleInputFieldError("subAdminPermission", null)} />
              </div>
            ))}
          </FormGroup>
          {inputFieldError?.subAdminPermission && <div style={{ color: "#D32F2F", fontSize: "10px", padding: "10px 0 0 15px" }}>{inputFieldError?.subAdminPermission}</div>}
        </Grid>

        <Grid item>
          <div onClick={() => handleSubmit()} style={{ fontWeight: "500", backgroundColor: "#164E62", color: "#fff", padding: "10px 20px", borderRadius: "5px", cursor: "pointer", fontSize: "15px" }}>Submit</div>
        </Grid>
      </Grid>
    </div>
  );
};

export default AddSubAdmin;
